module.exports = __webpack_public_path__ + "static/img/产品中心-井下智能防爆终端-case.90c48fb5.png";